module.exports = __webpack_public_path__ + "img/logolist.f8fef405.jpg";